import styled from 'styled-components'

export const StyledButton = styled.button`
    display:flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border:none;
    width: 200px;
    font-size: 16px;
    background-color:#00DB5C;
    color: #fff;
    font-weight: 700;
`;